import { MdmCommand } from "@dashboard/devices/types/commands";
import { SortingState } from "@tanstack/react-table";

export const rowsPerPage = [10, 25, 50];

export const commandPollingInterval = 10000;

export const emptyCommandList: MdmCommand[] = [];

export function getSortDirection(sorting: SortingState) {
    if (!sorting.length || sorting[0].desc) {
        return "descending";
    }
    return "ascending";
}
